import styled from 'vue3-styled-components';

export const VirtualAccountContainer = styled.div`
  overflow: hidden;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  font-size: 25px;
  text-align: center;
  margin-bottom: 20px;
  color: #cc5803;
`;

export const AccountUseTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  border: 1px solid #e9ecef;
`;

export const Th = styled.th`
  background: #ddd;
  text-align: center;
  border-bottom: 2px solid #e9ecef;
  font-size: 15px;
  padding: 12px;
`;

export const Td = styled.td`
  padding: 12px;
  text-align: center;
  font-size: 15px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 10px;
`;

export const SubmitButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: #6b7280;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4b5563;
  }
`;